// The reader's choice across neuroplast.io's sites: each site's pages as
// plain HTML ("page"), or printed by its program in a terminal, as HTML
// with hotty ("hotty") or as text in cells ("text"). The bar shows it as a
// switch, "TUI mode" (sitebar -tui), on a site with one terminal, or as the
// slider, web | hotty | tui (sitebar -modes, modes.ts), on a site with
// both. A site whose bar has either imports this in its script, so that
// the choice is one: made on one site, it is every other's that asks. A
// site without a mode shows its nearest: the switch's one terminal is
// hotty, for text too.
//
// It is a cookie, npio-mode, since a site's own storage (localStorage) is
// its origin's alone: on neuroplast.io, for it and every subdomain; on any
// other host (a local server), for that host. It holds the choice for a
// year, and is sent nowhere else. Nothing here may throw: a site's script
// reads it in the page's head.

export type Mode = "page" | "hotty" | "text";

const NAME = "npio-mode";
const YEAR = 365 * 24 * 60 * 60;

/** The reader's choice, or null if they have made none. */
export function chosen(): Mode | null {
  try {
    for (const c of document.cookie.split(";")) {
      const [k, v] = c.trim().split("=");
      if (k !== NAME) continue;
      if (v === "page" || v === "hotty" || v === "text") return v;
      if (v === "tui") return "hotty"; // the switch's, before the slider
    }
  } catch {}
  return null;
}

/** Keeps the reader's choice, for every site that asks. */
export function choose(mode: Mode) {
  try {
    document.cookie = cookie(mode, location.hostname, location.protocol === "https:");
  } catch {}
}

/** The cookie that keeps mode, set from host: neuroplast.io's sites share
 * it, any other host keeps its own. */
export function cookie(mode: Mode, host: string, https: boolean): string {
  const shared = host === "neuroplast.io" || host.endsWith(".neuroplast.io");
  return `${NAME}=${mode}; Path=/; Max-Age=${YEAR}; SameSite=Lax` + (shared ? "; Domain=neuroplast.io" : "") + (https ? "; Secure" : "");
}
